import React, { HTMLAttributes, useMemo, useRef } from 'react';
import style from './Plan.module.scss';
import classnames from 'classnames';
import PlanFeatures from './PlanFeatures';
import { getName } from '../../utils/getPlanName';
import { ICustomPlan } from '../../model';
import classNames from 'classnames';

export interface IProps {
  plan: ICustomPlan;
  className?: HTMLAttributes<HTMLDivElement>['className'];
  spacerClassName?: HTMLAttributes<HTMLDivElement>['className'];
  wrapperClassName?: HTMLAttributes<HTMLDivElement>['className'];
}

const CustomPlan = ({plan, ...props}: IProps) => {
  const ref = useRef<HTMLDivElement>(null)

  const mainPlan = plan;

  const wpBadge = useMemo(() => {
    // @ts-ignore
    return window.styles?.[mainPlan.plan_id];
  }, []);

  const showWpBadge = Boolean( wpBadge?.text);

  return (
    <div className={classNames(style.plan_wrapper, props.wrapperClassName)}>
      <div className={classNames(style.plan_space, props.spacerClassName)}/>
      <div
        className={classnames(
          style.plan,
          wpBadge?.style ? {[style[wpBadge?.style]]: wpBadge?.style && wpBadge?.style !== "default"} : {},
          {[style.wp_badge]: showWpBadge},
          props.className
        )}
        data-plan-id={plan.plan_id}>
        {showWpBadge ? <div className={style.wp_badge_item}>{wpBadge?.text}</div> : ""}
        <div className={style.plan_top_part} ref={ref}>
          <h4 className={style.title}>
            {getName(plan)}
          </h4>
          <h6 className={style.subtitle}>{plan.display.subname ? plan.display.subname : ''}</h6>
        </div>


        {mainPlan && (mainPlan.features?.length || window?.shortDescriptions?.[mainPlan.plan_id]) ? (<>
          <hr className={style.divider}/>
          <PlanFeatures plan={mainPlan}/>
        </>) : <></>}
        {plan.customText ? <div className={classnames(style.upgrade)}>
          <a
            href={plan.customLink}
            className={classnames('button-primary button-primary_md upgrade-button', style.upgrade_button)}>
            {plan.customText}
          </a>
        </div> : ""}
      </div>
      <div className={classNames(style.plan_space, props.spacerClassName)}/>
    </div>
  );
};

export default CustomPlan;
